export const translations = {
  en: {
    appName: 'Cinema Zone',
    partnerLabel: 'Viu Distribution Partner',
    languageEnglish: 'English',
    languageTraditionalChinese: 'Traditional Chinese',
    languageSimplifiedChinese: 'Simplified Chinese',
    languageSelectorLabel: 'Language',
    browse: 'Browse',
    rentals: 'Rentals',
    myRentals: 'My rentals',
    account: 'Account',
    openUserMenu: 'Open user menu',
    signOut: 'Sign out',
    login: 'Login',
    signUp: 'Sign Up',
    emailLabel: 'E-mail:',
    homeHeroImageAlt: 'Cinema seats',
    homeHeroText: 'Rent Asian movies in Australia and New Zealand, then watch unlimited times for 24 hours after first playback.',
    hideSearchFilters: 'Hide search filters',
    showSearchFilters: 'Show search filters',
    searchPlaceholder: 'Search title, actor, keyword',
    allLanguages: 'All languages',
    allGenres: 'All genres',
    allCountries: 'All countries',
    loadingMovies: 'Loading movies...',
    cast: 'Cast',
    releaseYear: 'Release year',
    durationMinutes: '{{minutes}} min',
    authRequestError: 'We could not complete that request. Please check your details and try again.',
    authIntro: 'Cinema Zone, Viu Distribution Partner.',
    email: 'Email',
    name: 'Name',
    password: 'Password',
    alreadyHaveAccount: 'Already have an account?',
    newToCinemaZone: 'New to Cinema Zone?',
    completingLogin: 'Completing Login...',
    pleaseSignInRentals: 'Please sign in to view rentals.',
    purchasedAt: 'Purchased {{date}}',
    expiresAt: 'Expires {{date}}',
    firstPlaybackWindow: '24-hour window starts on first playback',
    play: 'Play',
    noRentals: 'No rentals yet.',
    movieNotFound: 'Movie not found',
    paypalNotConfigured: 'PayPal is not configured yet.',
    paypalNotCompleted: 'PayPal payment was not completed. Your rental has not been activated.',
    paypalConfirmError: 'Could not confirm the PayPal payment. Please try again.',
    paymentCancelled: 'Payment was cancelled. Your rental has not been activated.',
    paypalFailed: 'PayPal payment failed. Please try again or use Stripe.',
    paypalUnavailable: 'PayPal is not available right now.',
    paypalLoadError: 'Unable to load PayPal at this time.',
    loginBeforeRenting: 'Please login before renting this movie.',
    guestEmailRequired: 'Please enter your email address before continuing.',
    paymentStartError: 'Could not start payment. Please check your email address and try again.',
    loadingMovie: 'Loading movie...',
    watchTrailer: 'Watch trailer',
    movieTrailer: '{{title}} trailer',
    closeTrailer: 'Close trailer',
    trailerUnavailable: 'This trailer cannot be played inline.',
    trailerFallbackHint: 'Having trouble playing the trailer?',
    openInYouTube: 'Open in YouTube',
    rentalPrice: 'Rental price',
    unlimitedPlayback: 'Unlimited playback for 24 hours from first play.',
    rentNow: 'Rent Now',
    backToCatalog: 'Back to catalog',
    rentMovie: 'Rent {{title}}',
    rentalPeriodFirstPlay: '24 hours from first play',
    closePaymentOptions: 'Close payment options',
    confirmingPaypal: 'Confirming PayPal payment...',
    processing: 'Processing...',
    payWith: 'Pay with',
    loginToRent: 'Login to rent',
    loginToRentPrompt: 'Please login or sign up before choosing a payment method.',
    closeLoginOptions: 'Close login options',
    paymentReferenceMissing: 'Payment reference is missing.',
    paymentStatusError: 'Could not load payment status. Please login and try again.',
    paymentReceived: 'Payment received',
    rentalActiveOpening: 'Your rental is active. Opening the player now...',
    guestRentalEmailSent: 'Your rental is active. We sent the secure playback link to {{email}}.',
    watchNow: 'Watch now',
    confirmingPayment: 'We are confirming your payment and activating your rental.',
    webhookDelay: 'This usually takes a few seconds after the payment provider sends the confirmed webhook callback.',
    webhookStillWaiting: 'Still waiting for the confirmed payment callback. You can stay here or check My rentals shortly.',
    paymentFailed: 'Payment failed. Your rental was not activated.',
    playbackUnavailable: 'Playback is unavailable. Please confirm your rental is active.',
    playback: 'Playback',
    rentalExpires: 'Rental expires {{date}}',
    playerTitle: 'Cinema Zone movie player',
    preparingPlayback: 'Preparing secure playback...',
    startMovie: 'Start movie',
    startMovieNotice: 'Once you start the movie, your 24-hour viewing window will begin.',
    regionUnavailableTitle: 'Service unavailable in your region',
    regionUnavailableMessage: 'Cinema Zone is currently available only in Australia and New Zealand.',
    adminTitle: 'Admin MVP',
    adminDescription: 'The backend exposes protected admin endpoints for movie upload, activation, rentals, and payments.',
  },
  'zh-Hant': {
    appName: 'Cinema Zone',
    partnerLabel: 'Viu 發行合作夥伴',
    languageEnglish: 'English',
    languageTraditionalChinese: '繁體中文',
    languageSimplifiedChinese: '简体中文',
    languageSelectorLabel: '語言',
    browse: '瀏覽',
    rentals: '租借',
    myRentals: '我的租借',
    account: '帳戶',
    openUserMenu: '開啟用戶選單',
    signOut: '登出',
    login: '登入',
    signUp: '註冊',
    emailLabel: '電郵：',
    homeHeroImageAlt: '戲院座位',
    homeHeroText: '在澳洲及紐西蘭租看亞洲電影，首次播放後 24 小時內可不限次數觀看。',
    hideSearchFilters: '隱藏搜尋篩選',
    showSearchFilters: '顯示搜尋篩選',
    searchPlaceholder: '搜尋片名、演員、關鍵字',
    allLanguages: '所有語言',
    allGenres: '所有類型',
    allCountries: '所有國家/地區',
    loadingMovies: '正在載入電影...',
    cast: '演員',
    releaseYear: '上映年份',
    durationMinutes: '{{minutes}} 分鐘',
    authRequestError: '未能完成要求。請檢查資料後再試。',
    authIntro: 'Cinema Zone，Viu 發行合作夥伴。',
    email: '電郵',
    name: '姓名',
    password: '密碼',
    alreadyHaveAccount: '已經有帳戶？',
    newToCinemaZone: '第一次使用 Cinema Zone？',
    completingLogin: '正在完成登入...',
    pleaseSignInRentals: '請先登入以查看租借紀錄。',
    purchasedAt: '購買時間 {{date}}',
    expiresAt: '到期時間 {{date}}',
    firstPlaybackWindow: '24 小時觀看時限會在首次播放後開始',
    play: '播放',
    noRentals: '暫無租借紀錄。',
    movieNotFound: '找不到電影',
    paypalNotConfigured: 'PayPal 尚未設定。',
    paypalNotCompleted: 'PayPal 付款未完成，租借尚未啟用。',
    paypalConfirmError: '未能確認 PayPal 付款。請再試一次。',
    paymentCancelled: '付款已取消，租借尚未啟用。',
    paypalFailed: 'PayPal 付款失敗。請再試一次或使用 Stripe。',
    paypalUnavailable: 'PayPal 暫時無法使用。',
    paypalLoadError: '目前無法載入 PayPal。',
    loginBeforeRenting: '租借電影前請先登入。',
    guestEmailRequired: '繼續前請先輸入你的電郵地址。',
    paymentStartError: '未能開始付款。請檢查電郵地址後再試。',
    loadingMovie: '正在載入電影...',
    watchTrailer: '觀看預告片',
    movieTrailer: '《{{title}}》預告片',
    closeTrailer: '關閉預告片',
    trailerUnavailable: '此預告片無法在頁面內播放。',
    trailerFallbackHint: '無法播放預告片？',
    openInYouTube: '在 YouTube 開啟',
    rentalPrice: '租借價格',
    unlimitedPlayback: '首次播放後 24 小時內可不限次數觀看。',
    rentNow: '立即租借',
    backToCatalog: '返回目錄',
    rentMovie: '租借 {{title}}',
    rentalPeriodFirstPlay: '首次播放後 24 小時',
    closePaymentOptions: '關閉付款選項',
    confirmingPaypal: '正在確認 PayPal 付款...',
    processing: '處理中...',
    payWith: '使用',
    loginToRent: '登入以租借',
    loginToRentPrompt: '選擇付款方式前，請先登入或註冊。',
    closeLoginOptions: '關閉登入選項',
    paymentReferenceMissing: '缺少付款參考編號。',
    paymentStatusError: '未能載入付款狀態。請登入後再試。',
    paymentReceived: '已收到付款',
    rentalActiveOpening: '租借已啟用，正在開啟播放器...',
    guestRentalEmailSent: '租借已啟用。我們已將安全播放連結寄到 {{email}}。',
    watchNow: '立即觀看',
    confirmingPayment: '我們正在確認付款並啟用你的租借。',
    webhookDelay: '付款服務商傳送確認回調後，通常只需數秒即可完成。',
    webhookStillWaiting: '仍在等待付款確認回調。你可以留在此頁，或稍後查看我的租借。',
    paymentFailed: '付款失敗，租借未啟用。',
    playbackUnavailable: '無法播放。請確認你的租借仍然有效。',
    playback: '播放',
    rentalExpires: '租借到期時間 {{date}}',
    playerTitle: 'Cinema Zone 電影播放器',
    preparingPlayback: '正在準備安全播放...',
    startMovie: '開始播放電影',
    startMovieNotice: '開始播放電影後，你的 24 小時觀看時限將會開始。',
    regionUnavailableTitle: '你所在地區暫未能使用此服務',
    regionUnavailableMessage: 'Cinema Zone 目前只在澳洲及紐西蘭提供服務。',
    adminTitle: 'Admin MVP',
    adminDescription: '後端提供受保護的管理端點，用於電影上載、啟用、租借和付款。',
  },
  'zh-Hans': {
    appName: 'Cinema Zone',
    partnerLabel: 'Viu 发行合作伙伴',
    languageEnglish: 'English',
    languageTraditionalChinese: '繁體中文',
    languageSimplifiedChinese: '简体中文',
    languageSelectorLabel: '语言',
    browse: '浏览',
    rentals: '租借',
    myRentals: '我的租借',
    account: '账户',
    openUserMenu: '打开用户菜单',
    signOut: '退出登录',
    login: '登录',
    signUp: '注册',
    emailLabel: '电邮：',
    homeHeroImageAlt: '影院座位',
    homeHeroText: '在澳大利亚及新西兰租看亚洲电影，首次播放后 24 小时内可不限次数观看。',
    hideSearchFilters: '隐藏搜索筛选',
    showSearchFilters: '显示搜索筛选',
    searchPlaceholder: '搜索片名、演员、关键词',
    allLanguages: '所有语言',
    allGenres: '所有类型',
    allCountries: '所有国家/地区',
    loadingMovies: '正在加载电影...',
    cast: '演员',
    releaseYear: '上映年份',
    durationMinutes: '{{minutes}} 分钟',
    authRequestError: '未能完成请求。请检查资料后再试。',
    authIntro: 'Cinema Zone，Viu 发行合作伙伴。',
    email: '电邮',
    name: '姓名',
    password: '密码',
    alreadyHaveAccount: '已经有账户？',
    newToCinemaZone: '第一次使用 Cinema Zone？',
    completingLogin: '正在完成登录...',
    pleaseSignInRentals: '请先登录以查看租借记录。',
    purchasedAt: '购买时间 {{date}}',
    expiresAt: '到期时间 {{date}}',
    firstPlaybackWindow: '24 小时观看时限会在首次播放后开始',
    play: '播放',
    noRentals: '暂无租借记录。',
    movieNotFound: '找不到电影',
    paypalNotConfigured: 'PayPal 尚未设置。',
    paypalNotCompleted: 'PayPal 付款未完成，租借尚未启用。',
    paypalConfirmError: '未能确认 PayPal 付款。请再试一次。',
    paymentCancelled: '付款已取消，租借尚未启用。',
    paypalFailed: 'PayPal 付款失败。请再试一次或使用 Stripe。',
    paypalUnavailable: 'PayPal 暂时无法使用。',
    paypalLoadError: '目前无法加载 PayPal。',
    loginBeforeRenting: '租借电影前请先登录。',
    guestEmailRequired: '继续前请先输入你的电邮地址。',
    paymentStartError: '未能开始付款。请检查电邮地址后再试。',
    loadingMovie: '正在加载电影...',
    watchTrailer: '观看预告片',
    movieTrailer: '《{{title}}》预告片',
    closeTrailer: '关闭预告片',
    trailerUnavailable: '此预告片无法在页面内播放。',
    trailerFallbackHint: '无法播放预告片？',
    openInYouTube: '在 YouTube 打开',
    rentalPrice: '租借价格',
    unlimitedPlayback: '首次播放后 24 小时内可不限次数观看。',
    rentNow: '立即租借',
    backToCatalog: '返回目录',
    rentMovie: '租借 {{title}}',
    rentalPeriodFirstPlay: '首次播放后 24 小时',
    closePaymentOptions: '关闭付款选项',
    confirmingPaypal: '正在确认 PayPal 付款...',
    processing: '处理中...',
    payWith: '使用',
    loginToRent: '登录以租借',
    loginToRentPrompt: '选择付款方式前，请先登录或注册。',
    closeLoginOptions: '关闭登录选项',
    paymentReferenceMissing: '缺少付款参考编号。',
    paymentStatusError: '未能加载付款状态。请登录后再试。',
    paymentReceived: '已收到付款',
    rentalActiveOpening: '租借已启用，正在打开播放器...',
    guestRentalEmailSent: '租借已启用。我们已将安全播放链接发送到 {{email}}。',
    watchNow: '立即观看',
    confirmingPayment: '我们正在确认付款并启用你的租借。',
    webhookDelay: '付款服务商发送确认回调后，通常只需数秒即可完成。',
    webhookStillWaiting: '仍在等待付款确认回调。你可以留在此页，或稍后查看我的租借。',
    paymentFailed: '付款失败，租借未启用。',
    playbackUnavailable: '无法播放。请确认你的租借仍然有效。',
    playback: '播放',
    rentalExpires: '租借到期时间 {{date}}',
    playerTitle: 'Cinema Zone 电影播放器',
    preparingPlayback: '正在准备安全播放...',
    startMovie: '开始播放电影',
    startMovieNotice: '开始播放电影后，你的 24 小时观看时限将会开始。',
    regionUnavailableTitle: '你所在地区暂不能使用此服务',
    regionUnavailableMessage: 'Cinema Zone 目前仅在澳大利亚及新西兰提供服务。',
    adminTitle: 'Admin MVP',
    adminDescription: '后端提供受保护的管理端点，用于电影上传、启用、租借和付款。',
  },
} as const;

export type Locale = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
